export default __webpack_public_path__ + "static/media/wait-light.8a2a815e.svg";